import React, { useEffect, useState } from 'react'
import './index.scss'
import { Bscroll } from '@/components/bscroll'
// import Header from '@/components/header'
import { getDate } from '@/utils/getDate'
import { createNonceStr, md5, getLocationSearch } from '@/utils/utils'
import request from '@/utils/request'
import {commitmentApi} from '@/api'
const Commitment = () => {
  //获取token
  let getToken = getLocationSearch().token
  // let [issign, setSign] = useState(false);
  // 签署
  // const handlesign = () => {
  //   setSign(true)
  // }
  //司机名称
  let [driverName, setDriverName] = useState()
  //身份证号
  let [idCardNum, setIdCardNum] = useState()
  //车牌
  let [vehicleNo, setVehicleNo] = useState()
  useEffect(() => {
    let appKey = 'app_h5';
    let secret = '11dc72cf-88b0-46cd-91d7-b1a77fd69ee1';
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let token = getToken;
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    request.post(commitmentApi, {}, {
      appKey: appKey,
      timestamp: timestamp,
      random: random,
      token: token,
      sign: sign
    })
      .then((d) => {
        if (d.data.data) {
          let { driverName, idCardNum, vehicleNo } = d.data.data
          //设置
          setDriverName(driverName)
          setIdCardNum(idCardNum)
          setVehicleNo(vehicleNo)
        }

      })
    return () => {
    }
  }, [getToken])
  return (
    <div className="Commitment__box">
      {/* <Header tit="疫情防疫书" /> */}
      <div className="commitment-con__box">
        <Bscroll scrollX={false} scrollY={true} bounce={{bottom:false}}>
          <div>
            <div>
              <h2>
                本人：{driverName}
              </h2>
              <h2>
                身份证号码：{idCardNum}
              </h2>
              <h2>
                车牌：{vehicleNo}
              </h2>
              <p>
                应政府防疫要求，为进一步做好新冠肺炎疫情防控工作，本人将履行以下承诺：
            </p>
              <p>
                1、熟知国家、省、市及平台关于出租汽车驾驶员新冠肺炎疫情防控有关要求和工作指引，并严格按要求和指引做好各项疫情防控工作。
            </p>
              <p>
                2、严格做好个人健康监测，坚决不带病上岗，出现发热、乏力、干咳等可疑症状，主动向公司上报，并到定点医院发热门诊就诊。
            </p>
              <p>
                3、本人知悉并确认：如为了证明自身健康而伪造相关检测报告的，甚至最终发现确属新冠肺炎患者的，本人自愿承担因此而面临平台依据平台规则进行的处理，甚至治安管理处罚及/或刑事责任。
            </p>
              <h3>
                <span>承诺人：{driverName}</span>
              </h3>
              <h3>
                <span>车牌号码：{vehicleNo}</span>
              </h3>
              <h3>
                <span>签署日期：{getDate()}</span>
              </h3>
            </div>
          </div>
        </Bscroll>
      </div>
      {/* <footer>
        {
          issign ? <button className="issign">今日已签署</button> : <button className="nosign" onClick={handlesign}>已阅读完成同意并签约</button>
        }
      </footer> */}
    </div>
  )
}
export default Commitment
